<template>
  <div
    class="nav-wrap"
    :class="efClass"
  >
    <div class="nav-wrap-in">
      <header-area />
      <div class="nav_menuArea contentsBox">
        <div class="menuInLang">
          <ul class="typeLang">
            <li>
              <a
                active-class="none"
                exact
                @click.prevent="setLang('en')"
              >
                EN
              </a>
            </li>
            <li>
              <a
                active-class="none"
                exact
                @click.prevent="setLang('ko')"
              >
                KR
              </a>
            </li>
          </ul>
        </div>
        <div class="navList web">
          <nav class="nav_menu">
            <ul>
              <!--<li :class="routeName === 'main' ? 'active' : ''"><router-link :to="{ name: 'main' }">PULIP</router-link></li>-->
              <li :class="routeName === 'works' || routeName === 'works-orangelife' ? 'active' : ''"><router-link :to="{ name: 'works' }">Works</router-link></li>
              <li :class="routeName === 'culturepage' ? 'active' : ''"><router-link :to="{ name: 'culturepage' }">Culture</router-link></li>
              <!--<li :class="routeName === 'news' ? 'active' : ''"><router-link :to="{ name: 'news' }">News</router-link></li>-->
              <li :class="routeName === 'contact' ? 'active' : ''"><router-link :to="{ name: 'contact' }">Contact</router-link></li>
            </ul>
          </nav>
        </div>
      </div>

      <footer class="nav_footer web">
        <!-- 네비 하단 웹버전 -->
        <div class="copyRight">
          <div>
            <span>Do you need help?</span>
            <a href="mailto:hi@pulip.com">hi@pulip.com</a>
          </div>
        </div>
        <div class="ftrBtn">
          <ul>
            <li><a href="https://www.pulip.com/companyinfo">회사소개서</a></li>
            <li>
              <a
                href="javascript:;"
                @click.prevent="showPrivacyPolicyPop"
              >개인정보정책<span /></a>
            </li>
          </ul>
        </div>
      </footer>

      <div class="navFooterArea mobile">
        <!-- 네비 하단 모바일버전 -->
        <div class="nFAInner">
          <footer class="nav_footer">
            <div class="navList">
              <nav class="nav_menu">
                <ul>
                  <!--<li :class="routeName === 'main' ? 'active' : ''"><router-link :to="{ name: 'main' }">PULIP</router-link></li>-->
                  <li :class="routeName === 'works' || routeName === 'works-orangelife' ? 'active' : ''"><router-link :to="{ name: 'works' }">Works</router-link></li>
                  <!--<li :class="routeName === 'news' ? 'active' : ''"><router-link :to="{ name: 'news' }">News</router-link></li>-->
                  <li :class="routeName === 'culturepage' ? 'active' : ''"><router-link :to="{ name: 'culturepage' }">Culture</router-link></li>
                  <li :class="routeName === 'contact' ? 'active' : ''"><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                </ul>
              </nav>
            </div>
            <div class="copyRight">
              <div>
                <span>Do you need help?</span>
                <a href="mailto:hi@pulip.com">hi@pulip.com</a>
              </div>
            </div>
            <div class="snsArea">
              <ul>
                <li>
                  <a
                    href="https://www.facebook.com/pulip.comms"
                    target="_blank"
                  >Facebook</a>
                </li>
                <li>
                  <a
                    href="http://pulipblog.com"
                    target="_blank"
                  >Blog</a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/pulip.comms"
                    target="_blank"
                  >Instagram</a>
                </li>
              </ul>
            </div>
          </footer>
        </div>

        <div class="ftrBtn">
          <!-- 모바일 네비 : 하단텍스트 -->
          <ul>
            <li><a href="https://www.pulip.com/companyinfo">회사소개서</a></li>
            <li>
              <a
                href="javascript:;"
                @click.prevent="showPrivacyPolicyPop"
              >개인정보정책<span /></a>
            </li>
          </ul>
        </div>
      </div>

      <div class="quick_btn">
        <!-- 모바일 네비 고정버튼 : 하단박스 -->
        <ul>
          <li>
            <a
              href="javascript:;"
              @click.prevent="showStartProject"
            >{{ $t('common.menu.quickLink')[0] }}</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click.prevent="showRecruit"
            >{{ $t('common.menu.quickLink')[1] }}</a>
            <!--<span class="teamNum">3</span>-->
          </li>
          <li>
            <a
              href="javascript:;"
              @click.prevent="showPds"
            >{{ $t('common.menu.quickLink')[2] }}</a>
          </li>
        </ul>
      </div>
    </div>
    <privacy-policy />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import HeaderArea from './Header.vue'
import PrivacyPolicy from './PrivacyPolicy.vue'
import common from '@/shared/mixin/common.js'
export default {
  mixins: [common],
  name: 'Menu',
  data () {
    return {
      iptMail: '',
      efClass: ''
    }
  },
  components: {
    HeaderArea,
    PrivacyPolicy
  },
  computed: {
    ...mapState('common', {
      navigation: state => state.navigation
    }),
    routeName () {
      return this.$route.name
    }
  },
  watch: {
    navigation (newValue) {
      if (newValue) {
        this.efClass = 'active'
      } else {
        this.efClass = 'leave'
        setTimeout(() => {
          this.efClass = ''
        }, 600)
      }
    }
  },
  methods: {
    ...mapActions('common', {
      setPrivacyPolicyPopAction: 'setPrivacyPolicyPop'
    }),
    showPrivacyPolicyPop () {
      this.setPrivacyPolicyPopAction(true)
    }
  }
}
</script>
